import { FC, useState } from "react";
import logo from "../../assets/ar encyclopedy.png";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import { isAuthenticated } from "../../utils/authCheck";
import UserDrawer from "../userDrawer/userDrawer";
import LanguageDrawer from "./LanguageDrawer";

interface HeaderProps {
  hideLogo?: boolean;
  hideLanguageFlag?: boolean;
}

const Header: FC<HeaderProps> = ({ hideLogo, hideLanguageFlag }) => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogoClick = () => {
    navigate("/", { replace: true });
  };

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const renderPrivateHeader = () => (
    <>
      <button onClick={toggleDrawer(true)} className="dark:text-white">
        <MenuIcon />
      </button>
      <UserDrawer open={drawerOpen} onClose={toggleDrawer(false)} />
    </>
  );

  const renderPublicHeader = () => (
    <>
      {!hideLanguageFlag && (
        <IconButton onClick={toggleDrawer(true)}>
          <img
            src={`/flags/${language}.png`}
            alt={language}
            className="h-6 w-auto"
          />
        </IconButton>
      )}
      <LanguageDrawer open={drawerOpen} onClose={toggleDrawer(false)} />
    </>
  );

  return (
    <header className="bg-white dark:bg-darkSecondaryBackground py-4 px-4 sm:px-6 lg:px-8 shadow w-full">
      <div className="flex justify-between items-center w-full">
        <div className="flex justify-start items-center">
          {!hideLogo && (
            <img
              src={logo}
              alt="Logo"
              className="h-8 w-auto cursor-pointer"
              onClick={handleLogoClick}
            />
          )}
        </div>
        <div className="flex items-center">
          {isAuthenticated() ? renderPrivateHeader() : renderPublicHeader()}
        </div>
      </div>
    </header>
  );
};

export default Header;
